import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { useCurrency } from '../utils/currency';
export function ValueStackSection() {
  const {
    formatPrice
  } = useCurrency();
  const rows = [{
    label: 'Producto principal: Mapa 5R — 25 scripts + árbol de conversación',
    value: formatPrice(27),
    isBonus: false
  }, {
    label: 'Bono #1: Diagnóstico Flash en 3 Preguntas',
    value: formatPrice(17),
    isBonus: true
  }, {
    label: 'Bono #2: Cierres Suaves — 12 formas de pedir el pago',
    value: formatPrice(17),
    isBonus: true
  }, {
    label: 'Bono #3: Follow-up Inteligente — 7 mensajes para reactivar',
    value: formatPrice(13),
    isBonus: true
  }];
  return <section className="w-full bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-8" data-id="element-403">
      <div className="max-w-3xl mx-auto" data-id="element-404">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-405">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1A1A1A] mb-3" data-id="element-406">
            Todo lo que recibes hoy
          </h2>
          <p className="text-[#6B7280]" data-id="element-407">
            Un sistema completo. Un precio de lanzamiento.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-408">
          {/* Table header */}
          <div className="grid grid-cols-[1fr_auto] bg-[#0B6B3A] text-white px-6 py-4" data-id="element-409">
            <span className="text-sm font-bold uppercase tracking-wide" data-id="element-410">
              Producto / Bono
            </span>
            <span className="text-sm font-bold uppercase tracking-wide text-right" data-id="element-411">
              Valor
            </span>
          </div>

          {/* Rows */}
          {rows.map((row, i) => <div key={i} className={`grid grid-cols-[1fr_auto] px-6 py-4 border-b border-gray-100 last:border-0 ${row.isBonus ? 'bg-[#F0FDF4]' : 'bg-white'}`} data-id="element-412">
              <div className="flex items-start gap-3 pr-4" data-id="element-413">
                <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${row.isBonus ? 'bg-[#0B6B3A]' : 'bg-[#1A1A1A]'}`} data-id="element-414">
                  <Check className="w-3 h-3 text-white" data-id="element-415" />
                </div>
                <span className="text-sm text-[#1A1A1A] font-medium" data-id="element-416">
                  {row.label}
                </span>
              </div>
              <div className="text-right" data-id="element-417">
                {row.isBonus ? <div className="flex flex-col items-end" data-id="element-418">
                    <span className="text-xs text-[#6B7280] line-through" data-id="element-419">
                      {row.value}
                    </span>
                    <span className="text-sm font-bold text-[#0B6B3A]" data-id="element-420">
                      GRATIS
                    </span>
                  </div> : <span className="text-sm font-bold text-[#1A1A1A]" data-id="element-421">
                    {row.value}
                  </span>}
              </div>
            </div>)}

          {/* Total row */}
          <div className="grid grid-cols-[1fr_auto] px-6 py-4 bg-gray-50 border-t-2 border-gray-200" data-id="element-422">
            <span className="text-sm font-bold text-[#6B7280] uppercase tracking-wide" data-id="element-423">
              Valor total real:
            </span>
            <span className="text-sm font-bold text-[#6B7280] line-through text-right" data-id="element-424">
              {formatPrice(74)}
            </span>
          </div>

          {/* Price row */}
          <div className="grid grid-cols-[1fr_auto] px-6 py-5 bg-[#0B6B3A]" data-id="element-425">
            <div className="flex items-center gap-2" data-id="element-426">
              <Star className="w-5 h-5 text-[#DCF8C6]" data-id="element-427" />
              <span className="text-base font-bold text-white" data-id="element-428">
                Tu precio hoy:
              </span>
            </div>
            <span className="text-2xl font-black text-[#DCF8C6] text-right" data-id="element-429">
              {formatPrice(6.39)}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}